import { useEffect, useState } from 'react';

export function QuestionTitleInput({
  questionId,
  value,
  onChange,
}: {
  questionId: string;
  value: string;
  onChange: (id: string, updates: Partial<PolicyFormQuestion>) => void;
}) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    onChange(questionId, { title: localValue });
  }, [localValue, onChange, questionId]);

  return (
    <input
      type="text"
      value={localValue}
      onChange={e => {
        setLocalValue(e.target.value);
      }}
      className="flex-1 border-b border-transparent bg-transparent text-sm text-black outline-none focus:border-gray-400"
      placeholder="Question text"
    />
  );
}